import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import './Collectable.css';
import Library from '../utility/Library';
import tooltipEffect from '../utility/tooltipEffect';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Card from '../../components/cards/Card';

let rarityByFloor = [
  [92,8,0],
  [80,20,0],
  [50,49,1],
  [30,60,10]
]

export default class Collectable extends Component {

  state = { tooltip: null }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  getImg () {

    switch (this.props.src.type) {
    case "cardchoice": return "/images/bundle.png";
    case "cardbundle": return "/images/bundle.png";
    case "rarecard": return "/images/rare.png";
    case "rarecardchoice": return "/images/rare.png";
    case "gold": return "/images/gold.png";
    case "health": return "/images/health.png";
    case "shards": return "/images/soulshard.png";
    case "exp": return "/images/exp.png";
    case "insight": return "/images/insight.png";
    case "paws": return "/images/paws.png";
    case "coin": return "/images/coin.png";
    case "berry": return "/images/berry.png";
    case "remove": return "/images/remove.png";
    case "seed": return "/images/seed.png";
    case "gift": return "/images/gift.png";
    case "bottledexp": return "https://moa-pull.b-cdn.net/assets/ui/bottledexp.png";
    case "randompotion": return "/images/potion.png";
    case "key": return "/images/keys/key" + this.props.src.value + ".png";
    case "smallkey": return "/images/key.png";
    case "escape": return "/images/escape.png";
    case "power": return "/images/mazepower.png";
    default: return this.props.src.value.img;
    }
  }

  render () {

    let id = this.props.id;
    if (!id)
      id = this.props.src.type + "-collectable";

    return (
      <div id={id}
        className={(this.props.className || "") + " game-collectable"}
        >
        <div className="game-collectable-main-wrapper">
          <div id={id + '-main'} className="game-collectable-main"
                onPointerDown={e => {
                  if (!this.props.id) {
                    this.toggleTooltip(this.props.id, e.pointerType === "touch");
                    if (e.pointerType === "touch")
                      return;
                  }
                  this.props.onSelect(e);
                }}>
            <div className="game-collectable-img-wrapper">
                { 
                  this.props.src.type === "card" ?
                  <Card
                    key={"treasure-relic-" + this.props.src.value.key}
                    tier={this.props.src.run.data.devotion.cards.selected || 0}
                    src={this.props.src.value}/> :
                  <Img key={"treasure-relic-" + this.getImg()} src={this.getImg()}/>
                }
              <div className="game-collectable-shadow"/>
            </div>
          { this.props.src.type !== "key" && this.props.src.type !== "cardchoice" && this.props.src.type !== "remove" && this.props.src.value && !isNaN(this.props.src.value) && <div className="game-collectable-value">{this.props.src.value}</div> }
          </div>
        </div>
        {/*
          this.props.src.type === "card" && <div className="shop-article-info" onClick={e => { this.props.manager.setState({focus: this.props.src.value}); e.stopPropagation(); } }><Img src="/images/info.png"/></div>
        */}
        {
          this.props.id && this.props.src.value && this.props.src.value.effect &&
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === this.props.id} target={this.props.id + '-main'} toggle={() => this.toggleTooltip(this.props.id)}>
            <b>{ this.props.src.type === "relic" ? <img src={"/images/relic.png"}/> : "" }{ this.props.src.value.name }</b>
            { this.props.src.type === "card" ? "" : <span><br/>{tooltipEffect(this.props.src.value.effect.replace(/\b[DBVFM]:(\d+)\b/g, (_, number) => number).replace(/\{([\w-]+)+(?::\d+)?\}/g, (_, number) => Library.getCard(number).name))}</span> }
            { this.tooltipTouch && <div className="tooltip-button" onClick={e => this.props.onSelect(e)}>{translate("Collect")}</div> }
          </Tooltip>
        }
        {
          ["berry", "coin", "seed", "remove", "randompotion", "bottledexp"].includes(this.props.src.type) &&
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === id} target={id} toggle={() => this.toggleTooltip(id)}>
            { this.props.src.type === "berry" && <span><b>{translate("Heart berry")}</b><br/>{translate("Recover ") + this.props.src.run.berryHp + " HP."}</span> }
            { this.props.src.type === "coin" && <span><b>{translate("Sacred coin")}</b><br/>{translate("Gain ") + this.props.src.run.coinGold + translate(" gold.")}</span> }
            { this.props.src.type === "seed" && <span><b>{translate("Growth seed")}</b><br/>{translate("Gain ") + this.props.src.run.seedExp + translate(" exp.")}</span> }
            { this.props.src.type === "bottledexp" && <span><b>{translate("Stolen exp")}</b></span> }
            { this.props.src.type === "paws" && <span><b>{translate("Menagerie token")}</b><br/>{translate("Can be exchanged at the menagerie.")}</span> }
            { this.props.src.type === "remove" && <span>{translate("Remove a card from your deck.")}</span> }
            { this.props.src.type === "randompotion" && <span>{translate("Get a random potion.")}</span> }
          </Tooltip>
        }
        {/*
          this.props.src.type === "cardchoice" &&
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === id} target={id} toggle={() => this.toggleTooltip(id)}>
            <span>
              <b>Card choice</b><br/>
              {"Common: " + rarityByFloor[this.props.src.run.floor-1][0] + "%."}<br/>
              {"Uncommon: " + rarityByFloor[this.props.src.run.floor-1][1] + "%."}<br/>
              {"Rare: " + rarityByFloor[this.props.src.run.floor-1][2] + "%."}
              </span>
          </Tooltip>
        */}
      </div>
    );
  }
}

